import { distancesStore } from '../stores';

function isValidDistance(id: number | null | string | null) {
  return !!distancesStore.find(+id!);
}

export const validateData = {
  isValidDistance,
};
